export default {
	getSideBarToggleProperties: (state) => state.sidebarToggleProperties,
}
